import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable ,  of } from 'rxjs';
import { TranslationBasePipe } from './translation-base-pipe';

/**
 * @ngModule SharedModule
 * @whatItDoes Truncates a string to a given maximum length.
 * @howToUse `string_expression | truncate:length`
 * @description
 *
 * Use `truncate` to truncate a string.
 */
@Pipe({
  name: 'truncate'
})
export class TruncatePipe extends TranslationBasePipe implements PipeTransform {
  constructor(translate: TranslateService, changeDetector: ChangeDetectorRef) {
    super(translate, changeDetector);
  }

  protected performTranslation(text: any, args: any[]): Observable<string> {
    const length = args && args.length && args[0] !== null && args[0] !== undefined ? Number(args[0]) : null;
    if (length === null || length >= (text || '').length) {
      return of(text);
    }

    return this.translateService.get('COMMON.TRUNCATED_TEXT', { text: (text || '').substring(0, Math.max(0, length)) });
  }
}
